// Utilities for Master Plot + Plot Portion rendering.

export const DIRECTION_LABEL = {
  F: "Full plot",
  N: "North",
  S: "South",
  E: "East",
  W: "West",
  NE: "North-East",
  NW: "North-West",
  SE: "South-East",
  SW: "South-West",
  P1: "Portion 1",
  P2: "Portion 2",
  P3: "Portion 3",
  P4: "Portion 4",
};

// Compact color source of truth (kept in sync with STATUS_META in statusUtils.js
// but duplicated here so this file has zero cross-imports and stays cheap).
const COLOR_APPROVED_VACANT = "#347355";       // green
const COLOR_APPROVED_PARTIAL = "#D97736";      // orange
const COLOR_APPROVED_SOLD = "#858585";         // grey
const COLOR_APPROVED_BOOKED = "#2C5E7A";       // blue
const COLOR_PENDING = "#EAB308";               // amber/yellow — matches Pending badge
const COLOR_REJECTED = "#B6B4AD";              // muted grey — inert / do not book

/**
 * Return the tile background color for a portion sub-region, taking BOTH the
 * portion's sale status and its approval_status into account.
 *
 *   approval=pending_approval  → yellow  (regardless of sale status)
 *   approval=rejected          → muted grey
 *   approval=approved (default):
 *     status=fully_vacant      → green
 *     status=booked            → blue
 *     status=sold              → grey
 *     status=partially_vacant  → orange   (rare on a portion but handled)
 */
export function portionDisplayColor(portion) {
  const approval = (portion && portion.approval_status) || "approved";
  if (approval === "pending_approval") return COLOR_PENDING;
  if (approval === "rejected") return COLOR_REJECTED;
  const s = portion && portion.status;
  if (s === "booked") return COLOR_APPROVED_BOOKED;
  if (s === "sold") return COLOR_APPROVED_SOLD;
  if (s === "partially_vacant") return COLOR_APPROVED_PARTIAL;
  return COLOR_APPROVED_VACANT;
}

// Sub-region position for a direction inside a master-plot tile.
// Each returns absolute-positioning props for a <div> overlay.
export function directionRegion(direction) {
  switch (direction) {
    case "N":
      return { position: "absolute", left: 0, right: 0, top: 0, height: "50%" };
    case "S":
      return { position: "absolute", left: 0, right: 0, bottom: 0, height: "50%" };
    case "E":
      return { position: "absolute", top: 0, bottom: 0, right: 0, width: "50%" };
    case "W":
      return { position: "absolute", top: 0, bottom: 0, left: 0, width: "50%" };
    case "F":
    default:
      return { position: "absolute", inset: 0 };
  }
}

// Given a list of portions, pick the "primary" direction to show as the label
// when the master plot has 2+ portions (used in map tiles).
export function primaryPortionLabel(portions) {
  if (!portions || portions.length === 0) return "";
  if (portions.length === 1) return "";
  // Show a compact indicator like "N/S" or "E/W" in the tile.
  return portions.map((p) => p.direction).join("/");
}
